import { useMemo } from 'react'
import { convertMarkdownInclusionsToArray } from 'lib/markdownUtil'

export function useAllInclusions(
  commonInclusions: App.PackageInclusion[],
  bonusInclusions: App.PackageInclusion[],
  tacticalInclusions: App.PackageInclusion[],
): App.TileInclusion[] {
  return useMemo(() => {
    const allInclusions = [...tacticalInclusions, ...bonusInclusions, ...commonInclusions]
    const inclusions: App.TileInclusion[] = []
    allInclusions.forEach((bonusInclusion) => {
      if ((bonusInclusion?.descriptionV2List?.length ?? 0) > 0) {
        return bonusInclusion.descriptionV2List?.map((inclusionV2) => {
          inclusions.push({
            text: inclusionV2.text,
            isHighlighted: inclusionV2.isHighlighted,
            icon: inclusionV2?.icon,
          })
        })
      } else {
        const description = bonusInclusion?.description?.startsWith('-') ?
          bonusInclusion?.description?.slice(1).trim() :
          bonusInclusion.description

        const descriptionLines = description ? convertMarkdownInclusionsToArray(description) : []
        descriptionLines.map((line) => {
          inclusions.push({
            text: line,
            isHighlighted: false,
            icon: bonusInclusion?.categoryIcon || '',
            minDuration: bonusInclusion?.minDuration,
            maxDuration: bonusInclusion?.maxDuration,
          })
        })
      }
    })

    return inclusions
  }, [commonInclusions, bonusInclusions, tacticalInclusions])
}
